import Swiper from 'swiper/dist/js/swiper.js';

export const arWorkSwiper = [];

$('.swiper-container--work').each(function (index) {
    var $el = $(this),
        $elPag = $el.find('.swiper-pagination--work'),
        $elNavLeft = $el.find('.swiper-button-next--work'),
        $elNavRight = $el.find('.swiper-button-prev--work'),
        $elFraction = $el.find('.swiper-fraction--work');

    $el.addClass(`swiper-container--work-${index}`);
    $elPag.addClass(`swiper-pagination--work-${index}`);
    $elNavLeft.addClass(`swiper-button-next--work-${index}`);
    $elNavRight.addClass(`swiper-button-prev--work-${index}`);
    $elFraction.addClass(`swiper-fraction--work-${index}`);

    arWorkSwiper[index] = new Swiper(`.swiper-container--work-${index}`, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        speed: 900,
        autoHeight: true,
        simulateTouch: false,
        init: false,
        mousewheel: false,
        pagination: {
            el: `.swiper-pagination--work-${index}`,
            clickable: true,
            type: 'bullets',
        },
        navigation: {
            nextEl: `.swiper-button-next--work-${index}`,
            prevEl: `.swiper-button-prev--work-${index}`,
        }
    });

    arWorkSwiper[index].init();
});



// WEBPACK FOOTER //
// ./frontend/components/slider/content-slider.js